<template>
  <div class="container">
    <div id="header">
      <div class="flex flex-row-left margin-top-20">
        <div class="flex-item-center">
          <el-form :inline="true" :model="formInline" class="demo-form-inline" @submit.prevent="onSubmit">
            <el-form-item label="订单号相关">
              <el-input
                style="width: 200px"
                v-model="formInline.saleOrder"
                placeholder="马帮订单号,交易号"
                clearable
                @keyup.enter="onSubmit"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="margin-20-0">
      <div>
        <el-table
          :max-height="dynamicHeight"
          :data="tableData"
          :preserve-expanded-content="true"
          :stripe="true"
          :border="true"
          :highlight-current-row="true"
          size="default"
        >
          <el-table-column
            label="交易号"
            min-width="160"
            prop="salesRecordNumber"
          ></el-table-column>
          <el-table-column
            label="订单编号"
            min-width="160"
            prop="PlatformOrderId"
          ></el-table-column>
          <el-table-column
            label="店铺"
            min-width="130"
            prop="shopName"
          ></el-table-column>
          <el-table-column
            label="客户"
            min-width="120"
            prop="BuyerUserId"
          ></el-table-column>
          <el-table-column
            label="币别"
            min-width="80"
            prop="currencyId"
          ></el-table-column>
          <el-table-column
            label="SKU及数量"
            min-width="180"
          >
            <template #default="scope">
              <div class="multi-line-ellipsis">
                <div v-for="(line, index) in scope.row.sku.split('\n')" :key="index" class="line-ellipsis" :title="line">{{ line }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="出库仓"
            min-width="220"
          >
            <template #default="scope">
              <div class="multi-line-ellipsis">
                <div v-for="(line, index) in scope.row.stockWarehouseNames.split('\n')" :key="index" class="line-ellipsis" :title="line">{{ line }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="金蝶订单号"
            min-width="120"
            prop="kingdee_xsddh"
          ></el-table-column>
          <el-table-column
            label="金蝶出库单号"
            min-width="120"
            prop="kingdee_xsckdh"
          ></el-table-column>
          <el-table-column
              label="金额及税额"
              min-width="180"
          >
            <template #default="scope">
              <div class="multi-line-ellipsis">
                <div v-for="(line, index) in scope.row.prices.split('\n')" :key="index" class="line-ellipsis" :title="line">{{ line }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作状态"
            min-width="120"
            prop="status"
          >
            <template #default="scope">
              <span v-if="scope.row.status === 0">待拉取马帮信息</span>
              <span v-else-if="scope.row.status === 1">待推送订单</span>
              <span v-else-if="scope.row.status === 2">待推送出库单</span>
              <span v-else-if="scope.row.status === 3">已完结</span>
              <span v-else>{{ scope.row.status }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="订单备注"
            min-width="150"
            prop="remark"
          ></el-table-column>
          <el-table-column
            label="马帮创建日期"
            min-width="150"
            prop="CreateTime"
          ></el-table-column>
          <el-table-column
            label="操作"
            min-width="120"
            fixed="right"
          >
            <template #default="scope">
              <div class="operation-buttons">
                <el-button
                  type="warning"
                  size="small"
                  :disabled="scope.row.status > 1"
                  :loading="loadingRow === scope.row"
                  @click="handlePullInfo(scope.row)"
                  style="margin-bottom: 5px;"
                >
                  拉取马帮信息
                </el-button>
                <el-button
                  type="primary"
                  size="small"
                  :disabled="scope.row.status !== 1"
                  @click="handlePushOrder(scope.row)"
                  style="margin-bottom: 5px;"
                >
                  下推订单
                </el-button>
                <el-button
                  type="success"
                  size="small"
                  :disabled="scope.row.status !== 2"
                  @click="handlePushStock(scope.row)"
                >
                  下推出库单
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flex flex-row-center flex-item-center margin-10-0 pagination">
        <el-pagination
          v-model:current-page="currentPage"
          :page-size="pageSize"
          :total="pageTotal"
          :page-sizes="[10, 20, 30, 50]"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          layout="total, sizes, prev, pager, next"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  ElButton,
  ElForm,
  ElFormItem,
  ElInput,
  ElPagination,
  ElTable,
  ElTableColumn,
  ElMessageBox,
  ElMessage
} from "element-plus";
import DynamicHeightMixin from "../../../public/js/dynamicHeightMixin";
import { get_mabang_offline_order, get_mabang_order_detail, push_kingdee_order, push_saleOrder } from "@/utils/api";

export default {
  name: "mabangToKindee",
  components: {
    ElForm,
    ElFormItem,
    ElButton,
    ElInput,
    ElTable,
    ElTableColumn,
    ElPagination
  },
  mixins: [DynamicHeightMixin],
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      pageTotal: 0,
      formInline: {
        saleOrder: ""
      },
      tableData: [],
      loadingRow: null // 用于跟踪正在加载的行
    };
  },
  mounted() {
    this.getMabangOfflineOrderData();
  },
  methods: {
    onSubmit(event) {
      if (event) {
        event.preventDefault();
      }
      this.currentPage = 1;
      this.getMabangOfflineOrderData();
    },
    getMabangOfflineOrderData() {
      const params = {
        PageNumber: this.currentPage,
        PageSize: this.pageSize,
        ...this.formInline
      };
      
      get_mabang_offline_order(params)
        .then(res => {
          console.log(res);
          this.tableData = res.Data || [];
          this.pageTotal = res.Total || 0;
        })
        .catch(err => {
          console.error(err);
          this.tableData = [];
          this.pageTotal = 0;
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getMabangOfflineOrderData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getMabangOfflineOrderData();
    },
    // 拉取马帮信息操作
    handlePullInfo(row) {
      ElMessageBox.confirm(
        '确定要拉取该订单的马帮信息吗？',
        '拉取马帮信息确认',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        // 设置当前行的loading状态
        this.loadingRow = row;
        
        // 调用实际的拉取马帮信息接口
        const params = {
          saleOrder: row.salesRecordNumber,
          shopId: row.shopId
        };
        
        get_mabang_order_detail(params)
          .then(res => {
            if (res.Code === 0) {
              // 操作成功
              ElMessage.success('马帮信息拉取成功');
              // 保持当前查询条件，重新查询数据
              this.getMabangOfflineOrderData();
            } else {
              ElMessage.error(res.Msg || '马帮信息拉取失败');
              // 清除loading状态
              this.loadingRow = null;
            }
          })
          .catch(err => {
            console.error(err);
            ElMessage.error('马帮信息拉取失败');
            // 清除loading状态
            this.loadingRow = null;
          });
      }).catch(() => {
        // 用户取消操作
        ElMessage.info('已取消拉取马帮信息');
      });
    },
    // 下推订单操作
    handlePushOrder(row) {
      ElMessageBox.confirm(
        '确定要下推该订单到金蝶系统吗？',
        '下推订单确认',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        // 调用实际的下推订单接口
        const params = {
          saleOrder: row.salesRecordNumber
        };
        
        push_kingdee_order(params)
          .then(res => {
            if (res.Code === 0) {
              // 操作成功
              ElMessage.success('订单下推成功');
              // 保持当前查询条件，重新查询数据
              this.getMabangOfflineOrderData();
            } else {
              ElMessage.error(res.Msg || '订单下推失败');
            }
          })
          .catch(err => {
            console.error(err);
            ElMessage.error('订单下推失败');
          });
      }).catch(() => {
        // 用户取消操作
        ElMessage.info('已取消下推订单');
      });
    },
    // 下推出库单操作
    handlePushStock(row) {
      ElMessageBox.confirm(
        '确定要下推出库单到金蝶系统吗？',
        '下推出库单确认',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        // 调用实际的下推出库单接口
        const params = {
          saleOrder: row.kingdee_xsddh
        };
        
        push_saleOrder(params)
          .then(res => {
            if (res.Code === 0) {
              // 操作成功
              ElMessage.success('出库单下推成功');
              // 保持当前查询条件，重新查询数据
              this.getMabangOfflineOrderData();
            } else {
              ElMessage.error(res.Msg || '出库单下推失败');
            }
          })
          .catch(err => {
            console.error(err);
            ElMessage.error('出库单下推失败');
          });
      }).catch(() => {
        // 用户取消操作
        ElMessage.info('已取消下推出库单');
      });
    }
  }
};
</script>

<style scoped>
.container {
  width: 92%;
  margin: 0 auto;
}

::v-deep .container .el-form-item {
  margin-bottom: 0 !important;
}



.operation-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px 0;
}

.multi-line-ellipsis {
  word-break: break-word;
}

.line-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>